import { notifyError } from "@/utils/monitoring";
import type { Connect } from "@hooks/connection";
import * as checkout from "@imtbl/checkout-sdk";
import { CommerceWidget } from "./CommerceWidget";

export interface ConnectWalletWidgetProps {
  onClose: () => void;
  connect: Connect;
}

export function ConnectWalletWidget({
  onClose,
  connect,
}: ConnectWalletWidgetProps) {
  const connectWallet = async (event: checkout.CommerceSuccessEvent) => {
    if (event.type !== checkout.CommerceSuccessEventType.CONNECT_SUCCESS) {
      throw new Error("unexpected event type");
    }

    if (!event.data.walletProviderName) {
      throw new Error("no walletProvider found on the event");
    }
    await connect(event.data.provider, event.data.walletProviderName);

    onClose();
  };

  const onFailure = (event: checkout.CommerceFailureEvent) => {
    notifyError(
      new Error(`connect wallet widget failed: ${event.data.reason}`),
      "connectWalletWidget",
    );
  };

  return (
    <CommerceWidget
      params={{ flow: checkout.CommerceFlowType.CONNECT }}
      onClose={onClose}
      onSuccess={connectWallet}
      onFailure={onFailure}
    />
  );
}
